// src/config/quotas.js
//
// ⚠️ Doit rester synchronisé avec la limite serveur de
//    frontend/functions/services/chatService.js (~ligne 505 : `if (currentCount >= 3)`).
//    Contextes de build séparés (app front CRA vs Cloud Functions) → pas d'import
//    croisé possible, synchronisation MANUELLE.
//    ⛔ NE PAS importer ce fichier depuis frontend/functions (casserait le déploiement).
export const FREE_DAILY_SEARCHES = 3;
